import { MedicalServiceMarkAsRemovedCommand } from '@dreryk/egabinet-private-medical-service-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent } from '@dreryk/react-components';

import { medicalServiceTranslationKeys } from '../../translations';
import { useRefetchMedicalServices } from '../shared/queries/useRefetchMedicalServices';

type MedicalServiceRemoveActionRenderer = (renderProps: { removeMedicalService: () => Promise<void> }) => JSX.Element;

type MedicalServiceRemoveActionProps = {
   readonly medicalServiceId: number;
   readonly children: MedicalServiceRemoveActionRenderer;
};

export const MedicalServiceRemoveAction = (props: MedicalServiceRemoveActionProps): JSX.Element => {
   const refetchMedicalServices = useRefetchMedicalServices();
   const { executeAsync } = useCqrsCommand<void, void>(
      () => {
         const command = new MedicalServiceMarkAsRemovedCommand();
         command.id = props.medicalServiceId;
         return command;
      },
      {
         onSuccess: () => {
            refetchMedicalServices();
            dispatchSnackbarPositiveEvent(medicalServiceTranslationKeys.remove.confirmation.snackbar);
         },
      }
   );

   return (
      <>
         {props.children({
            removeMedicalService: executeAsync,
         })}
      </>
   );
};
